import * as types from './actionTypes';

export default (msg, hideAfter) => (dispatch) => {
  dispatch({
    type: types.SUCCESS_TOAST_REQUESTED,
    payload: {
      display: true,
      message: msg,
      timeout: hideAfter,
    },
  });
};
